import { SocialItem, ChoiceProps } from '../../../types/types';

const Choice: React.FC<ChoiceProps> = ({
  className,
  social,
  formData,
  handleChange,
  handleChoiceSelect,
}) => {
  const handleOptionSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event);
    handleChoiceSelect();
  };
  return (
    <div className={className}>
      {social.map((item: SocialItem) => (
        <label key={item.id} className={`${className}__label`}>
          <input
            type='radio'
            name='connection'
            value={item.title}
            checked={formData.connection === item.title}
            onChange={handleOptionSelect}
          />
          <span className={`${className}__icon`}>{item.svg}</span>
          <span className={`${className}__text text-micro`}>{item.title}</span>
        </label>
      ))}
    </div>
  );
};

export default Choice;
